<div *ngIf="fields">
  <ejs-treeview
    id="treeview"
    #treeview
    [fields]="fields"
    [fullRowNavigable]="true"
    expandOn="Click"
    (nodeSelected)="onNodeSelected($event)"
  >
    <ng-template #nodeTemplate="" let-data="">
      <span>{{ data.nodeText }}</span>
      <span class="e-badge e-badge-primary" *ngIf="data.count">{{
        data.count
      }}</span>
    </ng-template>
  </ejs-treeview>
</div>
